export default __webpack_public_path__ + "static/media/banner-active.3e82d858.svg";